/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { Component, EventEmitter, input, Output, ChangeDetectionStrategy } from '@angular/core';
import {
  CalendarTaskHeaderGroup,
  CalendarTasksGroup,
  CommonUtils,
} from '@infodata-group/inf-commons';
import jsPDF from 'jspdf';
import { PdfHelper } from '../export/pdf-helper';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'infl-calendar-horizontal-resources',
  templateUrl: './calendar-horizontal-resources.component.html',
  styleUrls: ['./calendar-horizontal-resources.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslatePipe],
})
export class CalendarHorizontalResourcesComponent {
  public resources = input<CalendarTaskHeaderGroup[]>();
  public resourceTitle = input<string>();
  public heightTitle = input(90);

  @Output() changeDisplay = new EventEmitter<CalendarTaskHeaderGroup>();

  collapse(group: CalendarTaskHeaderGroup) {
    group.isOpened = !group.isOpened;
    this.changeDisplay.emit(group);
  }

  onHover(group: CalendarTasksGroup, mouseIn = true) {
    group.backgroundColor = mouseIn ? CommonUtils.color('grey-f3') : null;
  }

  toPdf(doc: jsPDF) {
    doc.rect(10, 10, 220, 60);
    doc.text('Resources', 30, 30);
    let y = 70;
    for (const group of this.resources()) {
      PdfHelper.setFillColor(doc, CommonUtils.color('grey-c8'));
      doc.rect(10, y, doc.internal.pageSize.width - 20, 30, 'FD');
      doc.line(230, y, 230, y + 30);
      PdfHelper.setFillColor(doc, CommonUtils.color('white'));
      doc.text(group.label, 20, y + 20);
      y += 30;
      y = this.addPage(doc, y);
      for (const resource of group.tasksGroups) {
        const height = Math.floor(resource.height / 30) * 20 + 10;
        doc.rect(10, y, doc.internal.pageSize.width - 20, height);
        doc.line(230, y, 230, y + height);
        doc.text(resource.label, 20, y + 20);
        y += height;
        y = this.addPage(doc, y);
      }
    }
    return y;
  }

  private addPage(doc: jsPDF, y: number) {
    if (y + 40 > doc.internal.pageSize.height - 10) {
      doc.addPage();
      doc.rect(10, 10, 220, 60);
      doc.text('Resources', 30, 30);
      y = 70;
    }
    return y;
  }
}
